import {distinctUntilChanged, filter, map, shareReplay, startWith, switchMap, take, withLatestFrom} from 'rxjs/operators';
import {combineLatest, Observable, Subject} from 'rxjs';
import {mc} from '@px/helper/mc';
import {eq} from '@px/helper/num';
import {marginApi} from '@px/api/margin';
import {marginStorage} from '@px/storage/margin';
import {isSupportMarginTrading$} from '@px/streams-margin/abtest';
import {wwData$} from './worker-data';
import {currenciesCache$, isActivateMarginAccount$} from './config';
import {spot$} from './spot';

export const marginAccounts$: Observable<MarginAccount[]> = wwData$.pipe(
  filter((o) => o.type === 'margin-trade-accounts'),
  map((o) => o.data.accounts as MarginAccount[]),
  startWith([]),
  shareReplay(1)
);

export const loadWallets$ = new Subject<string>();

wwData$
  .pipe(
    filter((o) => o.type === 'update-margin-account-status'),
    map((o): {isActivateMarginAccount: boolean} => o.data),
    distinctUntilChanged()
  )
  .subscribe((data) => isActivateMarginAccount$.next(data.isActivateMarginAccount));

spot$.pipe(filter((spot) => spot.mode === 'Margin')).subscribe(({symbol}: SpotPair) => {
  if (symbol !== marginStorage.readMarginStorage().lastSymbol) {
    marginStorage.updateMarginStorage({lastSymbol: symbol});
  }
});

combineLatest([spot$, isSupportMarginTrading$])
  .pipe(filter(([spot, isSupportMarginTrading]) => spot.mode === 'Margin' && !isSupportMarginTrading))
  .subscribe(([spot]) => {
    // 重定向到spot
    mc.send('trade-pair', 'change', {type: 'Spot', symbol: spot.symbol});
  });

combineLatest([isActivateMarginAccount$, spot$])
  .pipe(
    filter(([isActivateMarginAccount]) => !!isActivateMarginAccount),
    take(1),
    switchMap(() => marginApi.getWallets())
  )
  .subscribe();

combineLatest([isActivateMarginAccount$, spot$, marginAccounts$])
  .pipe(
    filter(([isActivateMarginAccount]) => !!isActivateMarginAccount),
    map(([, spot, marginAccounts]) => marginAccounts.find((o) => o.currency === spot.baseCurrency)),
    filter((o) => o && eq(o.hourlyInterestRateEr, 0)),
    map((o) => o.currency),
    distinctUntilChanged()
  )
  .subscribe((currency) => loadWallets$.next(currency));

combineLatest([loadWallets$, currenciesCache$])
  .pipe(
    map(([currency, currenciesCache]) => (currency && currenciesCache.has(currency) ? currenciesCache.get(currency).code : null)),
    distinctUntilChanged(),
    switchMap((currencyCode) => marginApi.getWallets({currencyCode}))
  )
  .subscribe();
